import { Button } from "@/components/ui/button"
import { Heart, Sparkles } from "lucide-react"

const DeveloperSupport = () => {
  return (
    <section className="py-24 bg-muted/50">
     <div className="container">
        <div className="flex flex-col gap-8 items-center justify-center text-center">
          <div className="flex flex-col gap-4 max-w-[58rem]">
            <h2 className="text-3xl font-bold leading-tight sm:text-4xl md:text-5xl">
              Support Our Development
            </h2>
            <p className="text-lg text-muted-foreground sm:text-xl">
              Help us continue building amazing features and providing high-quality service to the Discord community.
            </p>
          </div>

          <div className="grid gap-8 md:grid-cols-2 max-w-5xl mx-auto w-full">
            <div className="relative flex flex-col items-center p-8 bg-background rounded-lg border shadow-sm order-2 md:order-1">
              <div className="p-3 bg-fembot-pink/10 rounded-full mb-4">
                <Heart className="w-8 h-8 text-fembot-pink" />
              </div>
              <h3 className="text-2xl font-bold mb-2">Ko-fi Support</h3>
              <p className="text-muted-foreground text-center mb-6">
                Make a quick and easy one-time contribution via Ko-fi to help us maintain and improve Fembot.
              </p>
              <div className="text-2xl font-bold mb-6 text-fembot-pink">
                Any Amount
              </div>
              <Button 
                size="lg"
                className="bg-fembot-pink hover:bg-fembot-pink/90 text-white w-full"
                onClick={() => window.open("https://ko-fi.com/JanIsHere", "_blank")}
              >
                Support on Ko-fi
              </Button>
            </div>

            <div className="relative flex flex-col items-center p-8 bg-background rounded-lg border shadow-sm order-1 md:order-2">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                <div className="bg-primary text-white px-4 py-1 rounded-full text-sm">
                  Recommended
                </div>
              </div>
              <div className="p-3 bg-primary/10 rounded-full mb-4">
                <Sparkles className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-2xl font-bold mb-2">Gift Card Support</h3>
              <p className="text-muted-foreground text-center mb-6">
                Support us with gift cards from popular platforms. Perfect for international supporters.
              </p>
              <div className="grid grid-cols-2 gap-3 w-full mb-6">
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <span className="w-4 h-4 rounded-full bg-primary/20 flex items-center justify-center">✓</span>
                  Amazon.de
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <span className="w-4 h-4 rounded-full bg-primary/20 flex items-center justify-center">✓</span>
                  Steam
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <span className="w-4 h-4 rounded-full bg-primary/20 flex items-center justify-center">✓</span>
                  Apple
                </div>
                <div className="flex items-center gap-2 text-sm text-muted-foreground">
                  <span className="w-4 h-4 rounded-full bg-primary/20 flex items-center justify-center">✓</span>
                  Paysafe
                </div>
              </div>
              <Button 
                size="lg"
                className="bg-primary hover:bg-primary/90 text-white w-full"
                onClick={() => window.location.href = "/donate"}
              >
                Send Gift Card
              </Button>
            </div>
          </div>
           </div>
        </div>
    </section>
  )
}

export default DeveloperSupport
